import styled from "styled-components";
import { CardContent } from "@material-ui/core";

export const CardContentHeader = styled(CardContent)`
    padding-bottom: ${({ theme }) => theme.spacing(1)}px;
`;
